/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Note/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import DeleteAction from './DeleteAction/index'
import React from 'react'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Note({
  children,
  viewPath = "/DesignSystem/LeadPreview/Content/Notes/Note",
  onChange
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let noteNotesValueData = fromData.useDataValue({ viewPath,
context: 'note',
path: 'notes',
})
let noteNotesChangeData = fromData.useDataChange({ viewPath,
context: 'note',
path: 'notes',
})
  return (<React.Fragment
>
<div
  data-testid="Note.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-aI8I': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--g-2-aI8I': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 marginTop={0}
 data="note.notes"
 value={noteNotesValueData}
 onChange={noteNotesChangeData}
>
{childProps => (
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
/>
)}
</TysiaTextareaContent>
)}
</TysiaTextarea>
<DeleteAction
  viewPath={`${viewPath}/DeleteAction`}
/>
</div>
{children}
</React.Fragment>)
}